export class QuestionTypeModel {

    public id: number = 0;
    public name: string = '';
    public code: string = '';
    public defaultRegex: string = '';

}
